import React from "react";
import AverageValue from "@client/components/valueDisplays/elementary/AverageValue";

const POWER_TOPICS = ["zige/pozar1/12v/val", "zige/pozar0/12v/val", "zige/meteo/12v/val"];

export const PowerHealthWidget: React.FC = () => (
  <div className="flex items-center justify-center h-full p-3 gap-2">
    <span className="text-sm text-muted-foreground">12V průměr:</span>
    <AverageValue topicIds={POWER_TOPICS} />
  </div>
);

export default React.memo(PowerHealthWidget);
